(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', '../model/ErrorResponse500', '../model/CreateAccount', '../model/Account', '../model/ErrorResponse400', '../model/Error', '../model/ChangeCurrentAccount', '../model/PendingAccounts', '../model/AddPending', '../model/MemberAccounts', '../model/Accounts', '../model/UpdateAccount', '../model/ResendAccountVerificationLink', '../model/Acquisition', '../model/Users', '../model/UserData'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ErrorResponse500'), require('../model/CreateAccount'), require('../model/Account'), require('../model/ErrorResponse400'), require('../model/Error'), require('../model/ChangeCurrentAccount'), require('../model/PendingAccounts'), require('../model/AddPending'), require('../model/MemberAccounts'), require('../model/Accounts'), require('../model/UpdateAccount'), require('../model/ResendAccountVerificationLink'), require('../model/Acquisition'), require('../model/Users'), require('../model/UserData'));
  } else {
    // Browser globals (root is window)
    if (!root.Swagger) {
      root.Swagger = {};
    }
    root.Swagger.AccountsApi = factory(root.Swagger.ApiClient, root.Swagger.ErrorResponse500, root.Swagger.CreateAccount, root.Swagger.Account, root.Swagger.ErrorResponse400, root.Swagger.Error, root.Swagger.ChangeCurrentAccount, root.Swagger.PendingAccounts, root.Swagger.AddPending, root.Swagger.MemberAccounts, root.Swagger.Accounts, root.Swagger.UpdateAccount, root.Swagger.ResendAccountVerificationLink, root.Swagger.Acquisition, root.Swagger.Users, root.Swagger.UserData);
  }
}(this, function(ApiClient, ErrorResponse500, CreateAccount, Account, ErrorResponse400, Error, ChangeCurrentAccount, PendingAccounts, AddPending, MemberAccounts, Accounts, UpdateAccount, ResendAccountVerificationLink, Acquisition, Users, UserData) {
  'use strict';

  /**
   * Accounts service.
   * @module api/AccountsApi
   * @version 1.0.0
   */

  /**
   * Constructs a new AccountsApi. 
   * @alias module:api/AccountsApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use, default to {@link module:ApiClient#instance}
   * if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the accountCreate operation.
     * @callback module:api/AccountsApi~accountCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Account} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new HUB user account.
     * 
     * @param {module:model/CreateAccount} body the content of the request used to create user account.
     * @param {String} sessionkey host sessionkey.
     * @param {module:api/AccountsApi~accountCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Account}
     */
    this.accountCreate = function(body, sessionkey, callback) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling accountCreate";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling accountCreate";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Account;

      return this.apiClient.callApi(
        '/accounts/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountCurrentGet operation.
     * @callback module:api/AccountsApi~accountCurrentGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Account} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get current user account.
     * @param {String} slug user slug.
     * @param {String} sessionkey host sessionkey value to validate host user session.
     * @param {module:api/AccountsApi~accountCurrentGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Account}
     */
    this.accountCurrentGet = function(slug, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling accountCurrentGet";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling accountCurrentGet";
      }


      var pathParams = {
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = Account;

      return this.apiClient.callApi(
        '/accounts/{slug}/current/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountCurrentSet operation.
     * @callback module:api/AccountsApi~accountCurrentSetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Set user current account.
     * @param {String} slug unique value to identify user.
     * @param {String} sessionkey value used to manage host session.
     * @param {module:model/ChangeCurrentAccount} body request data used to change current account.
     * @param {module:api/AccountsApi~accountCurrentSetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.accountCurrentSet = function(slug, sessionkey, body, callback) {
      var postBody = body;

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling accountCurrentSet";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling accountCurrentSet";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling accountCurrentSet";
      }


      var pathParams = {
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/accounts/{slug}/current/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountDetails operation.
     * @callback module:api/AccountsApi~accountDetailsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Account} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Detail View of logged in account.
     * user should be logged in to see detail view of account user is associated with.
     * @param {String} slug unique value which will be used to fetch user account details.
     * @param {String} sessionkey host sessionkey.
     * @param {module:api/AccountsApi~accountDetailsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Account}
     */
    this.accountDetails = function(slug, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling accountDetails";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling accountDetails";
      }


      var pathParams = {
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = Account;

      return this.apiClient.callApi(
        '/accounts/{slug}/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountInvitationDelete operation.
     * @callback module:api/AccountsApi~accountInvitationDeleteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a pending user from user account.
     * This can only be done by the logged in user.
     * @param {String} email Invited user email address.
     * @param {String} slug account unique indentifier.
     * @param {String} sessionkey value used to manage hub  user session.
     * @param {module:api/AccountsApi~accountInvitationDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.accountInvitationDelete = function(email, slug, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'email' is set
      if (email == undefined || email == null) {
        throw "Missing the required parameter 'email' when calling accountInvitationDelete";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling accountInvitationDelete";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling accountInvitationDelete";
      }


      var pathParams = {
        'email': email,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/accounts/{slug}/pendings/{email}/', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountInvitationList operation.
     * @callback module:api/AccountsApi~accountInvitationListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PendingAccounts} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get list of user&#39;s account pending users.
     * 
     * @param {String} slug account unique indentifier.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/AccountsApi~accountInvitationListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/PendingAccounts}
     */
    this.accountInvitationList = function(slug, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling accountInvitationList";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling accountInvitationList";
      }


      var pathParams = {
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = PendingAccounts;

      return this.apiClient.callApi(
        '/accounts/{slug}/pendings/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountInvitationSend operation.
     * @callback module:api/AccountsApi~accountInvitationSendCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Invite user to join account.
     * This can only be done by the logged in user.
     * @param {String} slug account unique indentifier.
     * @param {String} sessionkey user session key to validate user login.
     * @param {module:model/AddPending} body the content of the request used invite user.
     * @param {module:api/AccountsApi~accountInvitationSendCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.accountInvitationSend = function(slug, sessionkey, body, callback) {
      var postBody = body;

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling accountInvitationSend";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling accountInvitationSend";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling accountInvitationSend";
      }


      var pathParams = {
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/accounts/{slug}/pendings/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountLocalGet operation.
     * @callback module:api/AccountsApi~accountLocalGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Account} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get current user account.
     * @param {String} slug user slug.
     * @param {String} sessionkey host sessionkey value to validate host user session.
     * @param {module:api/AccountsApi~accountLocalGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Account}
     */
    this.accountLocalGet = function(slug, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling accountLocalGet";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling accountLocalGet";
      }


      var pathParams = {
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = Account;

      return this.apiClient.callApi(
        '/accounts/{slug}/local/current/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountLocalSet operation.
     * @callback module:api/AccountsApi~accountLocalSetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Set user current account.
     * @param {String} slug unique value to identify user.
     * @param {String} sessionkey value used to manage host session.
     * @param {module:model/ChangeCurrentAccount} body request data used to change current account.
     * @param {module:api/AccountsApi~accountLocalSetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.accountLocalSet = function(slug, sessionkey, body, callback) {
      var postBody = body;

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling accountLocalSet";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling accountLocalSet";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling accountLocalSet";
      }


      var pathParams = {
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/accounts/{slug}/local/current/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountMemberList operation.
     * @callback module:api/AccountsApi~accountMemberListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MemberAccounts} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get list of user&#39;s account pending users.
     * 
     * @param {String} slug account unique indentifier.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/AccountsApi~accountMemberListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/MemberAccounts}
     */
    this.accountMemberList = function(slug, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling accountMemberList";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling accountMemberList";
      }


      var pathParams = {
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = MemberAccounts;

      return this.apiClient.callApi(
        '/accounts/{slug}/members/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountMembershipList operation.
     * @callback module:api/AccountsApi~accountMembershipListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Accounts} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns all accounts associated with given user account
     * @param {String} slug unique value to identify user account.
     * @param {String} sessionkey value used to manage hub session.
     * @param {module:api/AccountsApi~accountMembershipListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Accounts}
     */
    this.accountMembershipList = function(slug, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling accountMembershipList";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling accountMembershipList";
      }


      var pathParams = {
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = Accounts;

      return this.apiClient.callApi(
        '/accounts/{slug}/accounts/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the accountUpdate operation.
     * @callback module:api/AccountsApi~accountUpdateCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update HUB User Account.
     * 
     * @param {String} slug user account slug.
     * @param {module:model/UpdateAccount} body request data used to update HUB user account.
     * @param {Object} opts Optional parameters
     * @param {String} opts.sessionkey host sessionkey.
     * @param {module:api/AccountsApi~accountUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.accountUpdate = function(slug, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling accountUpdate";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling accountUpdate";
      }


      var pathParams = {
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': opts['sessionkey']
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/accounts/{slug}/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the resendAccountVerificationEmail operation.
     * @callback module:api/AccountsApi~resendAccountVerificationEmailCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Resend Email Verification link to verifiy account if already not verified.
     * user should be logged in to resend the verification link.
     * @param {String} sessionkey account session.
     * @param {module:model/ResendAccountVerificationLink} body request data used to resend link to user account.
     * @param {module:api/AccountsApi~resendAccountVerificationEmailCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.resendAccountVerificationEmail = function(sessionkey, body, callback) {
      var postBody = body;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling resendAccountVerificationEmail";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling resendAccountVerificationEmail";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/accounts/resend/emailverification/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the revokeSharedPackage operation.
     * @callback module:api/AccountsApi~revokeSharedPackageCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete/revoke shared package from user account.
     * This can only be done by the logged in user.
     * @param {String} accountSlug account slug used to uniquely identify a package.
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/Acquisition} body request data used to acquire package.
     * @param {module:api/AccountsApi~revokeSharedPackageCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.revokeSharedPackage = function(accountSlug, slug, sessionkey, body, callback) {
      var postBody = body;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling revokeSharedPackage";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling revokeSharedPackage";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling revokeSharedPackage";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling revokeSharedPackage";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/acquisitions/', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the searchAccounts operation.
     * @callback module:api/AccountsApi~searchAccountsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Users} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Search accounts by starting keywords of account name .
     * user should be logged in to search accounts.
     * @param {String} sessionkey account session.
     * @param {String} pattern parameter to provide search accounts with passed starting keywords.
     * @param {module:api/AccountsApi~searchAccountsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Users}
     */
    this.searchAccounts = function(sessionkey, pattern, callback) {
      var postBody = null;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling searchAccounts";
      }

      // verify the required parameter 'pattern' is set
      if (pattern == undefined || pattern == null) {
        throw "Missing the required parameter 'pattern' when calling searchAccounts";
      }


      var pathParams = {
        'pattern': pattern
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Users;

      return this.apiClient.callApi(
        '/accounts/search/{pattern}/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userGet operation.
     * @callback module:api/AccountsApi~userGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserData} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new HUB user account.
     * 
     * @param {String} sessionkey host sessionkey.
     * @param {module:api/AccountsApi~userGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/UserData}
     */
    this.userGet = function(sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling userGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserData;

      return this.apiClient.callApi(
        '/accounts/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));



/*****************
 ** WEBPACK FOOTER
 ** ./~/swagger/src/api/AccountsApi.js
 ** module id = 272
 ** module chunks = 0
 **/